<app-capital-container size="M">
    <app-capital-back></app-capital-back>
    <p class="capital-title">Ingresa tu Clave de Acceso</p>
    <p class="welcome-subtitle">Esta es la misma clave con la que accedes al sitio web.</p>
    <app-capital-card>
        <div class="d-flex flex-column justify-content-center login-paddings">
            <app-capital-input placeholder="Ingresa tu RUT" [validator]="validateRut" formatter="rut"
                #rutinput></app-capital-input>
            <app-capital-input placeholder="Ingresa tu clave" [validator]="validatePassword" type="password"
                #passinput></app-capital-input>
            
            @if (errorMessage()) {
                <div class="alert alert-danger" role="alert">
                    {{ errorMessage() }}
                </div>
            }
            
            <app-primary-button 
                [text]="isLoading() ? 'Ingresando...' : 'Ingresar'" 
                [disabled]="!(rutinput.isValid() && passinput.isValid()) || isLoading()"
                (click)="onLogin(rutinput.value, passinput.value)">
            </app-primary-button>
        </div>
    </app-capital-card>
</app-capital-container>